interface EmptyStateProps {
  readonly eyebrow: string;
  readonly title: string;
  readonly description: string;
}

export function EmptyState({ description, eyebrow, title }: EmptyStateProps) {
  return (
    <section className="forq-empty-state">
      <span className="forq-eyebrow">{eyebrow}</span>
      <h1>{title}</h1>
      <p>{description}</p>
    </section>
  );
}
